import { ALERT_EVENTS } from '../constants/actionTypes';

export const initialState = {
  message: '',
  type: 'success',
};

const alertReducer = (state, { type, payload }) => {
  switch (type) {
    case ALERT_EVENTS.SET: {
      return { ...state, loading: false, ...payload };
    }

    case ALERT_EVENTS.RESET:
      return initialState;

    default:
      return state;
  }
};

export default alertReducer;
